/**
 *  Component: Function and grade
 */
import React from 'react';

import { Container } from 'styles/admin';

import FunctionAndGradeList from './FunctionAndGradeList';

const MeshTags = () => (
  <Container>
    <FunctionAndGradeList tagLabel="Function & Grade" tagTypeLabel="Function & Grade" />
  </Container>
);
export default MeshTags;
